<template>
  <index-page>

  </index-page>
</template>

<script>
// import HelloWorld from './components/HelloWorld.vue'
import IndexPage from './components/IndexPage.vue'

export default {
  name: 'app',
  components: {
    IndexPage
  },
  errorCaptured(err, vm, info) {
    
    let error_param = {
      type: 'error',
      title: '系統異常',
      icon: 'error',
      error_code: this.$bus.createErrorCode(vm.$options.name),
      error_message: this.$bus.pageCodeMapper[vm.$options.name].name + '頁面發生異常',
      content: err.stack.toString() 
    }

    this.$alert(error_param)

  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
